function renderLifecycleHookCodeImportsTemplate({
  adminImportAlias,
  schemaName,
  event,
  entityLabel,
  actionLabel
}: {
  adminImportAlias: string
  schemaName: string
  event: string
  entityLabel: string
  actionLabel: string
}): string {
  return `import { registerHook } from '${adminImportAlias}/lib/lifecycle-hooks'

registerHook('${schemaName}', '${event}', async (ctx) => {
  console.log('${entityLabel} ${actionLabel} requested', {
    actorId: ctx.user?.id ?? null,
    entityId: ctx.entityId,
    input: ctx.input
  })

  // Return an abort result to stop this mutation.
  // return { abort: true, reason: '${entityLabel} is not ready for this change' }
})
`
}

function renderLifecycleHookCodeImportsDetailsTemplate({
  adminImportAlias,
  schemaName,
  event,
  lifecycleHookId
}: {
  adminImportAlias: string
  schemaName: string
  event: string
  lifecycleHookId: string
}): string {
  return `import { registerHook } from '${adminImportAlias}/lib/lifecycle-hooks'

registerHook('${schemaName}', '${event}', async (ctx) => {
  await fetch('https://example.com/webhooks/${schemaName}/${lifecycleHookId}', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      actorId: ctx.user?.id ?? null,
      entityType: ctx.entityType,
      entityId: ctx.entityId,
      data: ctx.data
    })
  })
})
`
}

export function renderLifecycleHookCodeRenderer(
  request:
    | {
        kind: 'renderLifecycleHookCodeImportsTemplate'
        props: {
          adminImportAlias: string
          schemaName: string
          event: string
          entityLabel: string
          actionLabel: string
        }
      }
    | {
        kind: 'renderLifecycleHookCodeImportsDetailsTemplate'
        props: {
          adminImportAlias: string
          schemaName: string
          event: string
          lifecycleHookId: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderLifecycleHookCodeImportsTemplate':
      return renderLifecycleHookCodeImportsTemplate(request.props)
    case 'renderLifecycleHookCodeImportsDetailsTemplate':
      return renderLifecycleHookCodeImportsDetailsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
